import HamburgerMenu from "./Components/Pages/Nav/index";
import Galery from './Components/Pages/Galery/galery';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Abou from './Components/Pages/Home/index';
import Contact from "./Components/Pages/Contato/contato";
import RTable from './Components/Pages/RTable/Table';
import Terminal from "./Components/Pages/RTable/Terminal";
import Cart from './Components/Pages/Cart/Cart';
import Controller from './Components/Pages/Controller/index';
import Login from './Components/Pages/Log/login';

function Routers() {
    return (

        <>
            <Router>
                <HamburgerMenu />
                
                <div className="pages">
                    <Routes>
                        <Route  path="/" element={<Abou />} />
                        <Route path="/galery" element={<Galery />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/reserve" element={<RTable />} />
                        <Route path="/terminal" element={<Terminal />} />
                        <Route path="/cardapio" element={<Cart />} />
                        <Route path="/controller" element={<Controller />} /> 
                        <Route path="/login" element={<Login />} /> 
                    </Routes>
                </div>
            </Router>
        </>

    );
}

export default Routers;